export enum ScaleType {
  Ph = 'ph',
  Salt = 'salt',
  Orp = 'orp'
}

export interface ScaleConfig {
  title?: string;
  description?: string;
  scaleTitle?: string;
  min: number;
  max: number;
  step: number;
  zones: Zone[];
}

export enum ZoneLevel {
  Danger = 'danger',
  Warning = 'warning',
  Safe = 'safe'
}
export interface Zone {
  min: number;
  max: number;
  level: ZoneLevel;
}